import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, CarFront } from "lucide-react";
import { useSettings } from "@/hooks/useSettings";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const s = useSettings();

  const LINKS = [
    { to: "/", label: s.nav_home || "მთავარი" },
    { to: "/catalog", label: s.nav_catalog || "კატალოგი" },
    { to: "/about", label: s.nav_about || "ჩვენ შესახებ" },
    { to: "/blog", label: "ბლოგი" },
    { to: "/apply", label: s.nav_apply || "განაცხადი" },
  ];

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 bg-[#0A0B0E]/85 backdrop-blur-xl border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 text-white font-bold text-lg tracking-tight">
          <CarFront className="w-6 h-6 text-[#D4AF37]" />
          taxipark<span className="text-[#D4AF37]">.ge</span>
        </Link>

        <nav className="hidden md:flex items-center gap-1" data-testid="nav-desktop">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.to === "/" ? "home" : l.to.slice(1)}`}
              className={({ isActive }) =>
                `px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 ${
                  isActive ? "text-[#E5C378] bg-white/5" : "text-gray-300 hover:text-white hover:bg-white/5"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/catalog" data-testid="nav-cta" className="btn-gold !py-2 !px-5 ml-3 text-sm">
            აირჩიე მანქანა
          </Link>
        </nav>

        <div className="md:hidden flex items-center gap-2">
          <Link to="/catalog" data-testid="nav-mobile-quick-cta" className="btn-gold !py-2 !px-4 !min-h-0 text-xs">
            კატალოგი
          </Link>
          <button
            data-testid="nav-mobile-toggle"
            className="text-white p-2"
            onClick={() => setOpen(!open)}
            aria-label="მენიუ"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <nav className="md:hidden border-t border-white/10 bg-[#0A0B0E]/95 px-4 py-4 space-y-1" data-testid="nav-mobile">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              data-testid={`nav-mobile-link-${l.to === "/" ? "home" : l.to.slice(1)}`}
              className={({ isActive }) =>
                `block px-4 py-3 rounded-lg text-base font-medium ${
                  isActive ? "text-[#E5C378] bg-white/5" : "text-gray-300"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/catalog" onClick={() => setOpen(false)} data-testid="nav-mobile-cta" className="btn-gold w-full mt-2">
            აირჩიე მანქანა
          </Link>
        </nav>
      )}
    </header>
  );
}
